import { GA4_ADD_TO_WISHLIST } from '@common/Tracking';
import { ga4event } from '@helpers/dataLayer';

export const ga4AddToWishlistEvent = (itemsParameters = {}, interactionOrigin, tracking = {}) => {
    if (tracking && tracking.items?.length > 0) {
        const { items, ...commonTrackingData } = tracking;

        const modifiedItems = items.map(item => ({
            ...item,
            ...itemsParameters
        }));

        const eventData = {
            ...commonTrackingData,
            interaction_origin: interactionOrigin,
            items: modifiedItems
        };

        ga4event(GA4_ADD_TO_WISHLIST, eventData);
    }
};
